var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { string, node } from 'prop-types';
import styled from 'styled-components';
var StyledLink = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: #3380A7;\n\n  &::hover {\n    color: #3E6D85;\n  }\n  &::visited {\n    color: #3E6D85;\n  }\n"])));

function Link(_ref) {
  var _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      href = _ref.href,
      _ref$dataAnalyticsId = _ref.dataAnalyticsId,
      dataAnalyticsId = _ref$dataAnalyticsId === void 0 ? null : _ref$dataAnalyticsId,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? null : _ref$dataAnalyticsLab,
      restProps = _objectWithoutProperties(_ref, ["target", "className", "children", "href", "dataAnalyticsId", "dataAnalyticsLabel"]);

  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    href: href,
    target: target,
    className: className,
    "data-analytics-id": dataAnalyticsId,
    "data-test-id": "sharp-link",
    "data-analytics-label": dataAnalyticsLabel
  }, restProps), children);
}

Link.propTypes = {
  /**
  Optional for telling browser where to open link. It defaults to opening in a separate tab.
  */
  target: string,

  /**
  Optional className to include in rendered component
  */
  className: string,

  /**
  Required and refers to everything included between opening
  and closing tags when invoking component
  */
  children: node.isRequired,

  /**
  Required url for the link
  */
  href: string.isRequired,

  /**
  Optional analytics label to track user engagement
  */
  dataAnalyticsLabel: string,

  /**
  Unique analytics id to track user engagement
  */
  dataAnalyticsId: string
};
export default Link;